export default function confirm(message) {
  return window.confirm(message);
}
